import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import Keycloak from 'keycloak-js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (environment.contentLinks['favicon'] !== undefined) {
 document.querySelector('link[rel="shortcut icon"]').setAttribute('href', environment.contentLinks.favicon);
}
console.info('Using process server: ' + environment.server.url);
// keycloak init options
const initOptions = {
  url: 'https://auth.knowprocess.com/auth', realm: 'knowprocess', clientId: 'tasks-ng'
};

const keycloak = Keycloak(initOptions);
// Expose keycloak globally for logout
(window as any).keycloak = keycloak;

// Initialize Keycloak before bootstrapping Angular
keycloak.init({
  onLoad: 'check-sso',
  checkLoginIframe: false
}).then((authenticated) => {
  console.log(authenticated ? 'User is authenticated' : 'User is not authenticated');

  platformBrowser().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}).catch(() => {
  console.error('Keycloak initialization failed');

  // Bootstrap anyway to show error UI
  platformBrowser().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
